module.exports = __webpack_public_path__ + "static/pocketcasts-62b12ef7edb38d8f8faf739f8b6548ff.png";